import { useGet, UseGetOptions } from '../../../hooks/useApi';

interface AttendanceLogParams {
  studentId: number;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
}

interface AttendanceLogRecord {
  id: number;
  studentId: number;
  date: string;
  signInTime?: string;
  signOutTime?: string;
  signInSignature?: string;
  signOutSignature?: string;
  parentName: string;
  parentPhone: string;
}

export const useAttendanceLog = (params: AttendanceLogParams) => {
  const queryParams: Record<string, any> = {};

  if (params.startDate) queryParams.startDate = params.startDate;
  if (params.endDate) queryParams.endDate = params.endDate;
  if (params.limit) queryParams.limit = params.limit.toString();
  if (params.offset) queryParams.offset = params.offset.toString();

  const options: UseGetOptions = {
    queryKey: ['attendanceLog', params],
    params: queryParams,
    enabled: !!params.studentId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  };

  return useGet<AttendanceLogRecord[]>(
    `/v1/auth/attendance/student/${params.studentId}/log`,
    options
  );
};
